import { ingestAPIObject } from "../utils/api";
export class NurseryDTO {
    constructor(jsonData) {
        ingestAPIObject(this, jsonData);
    }
}
